import { supabase } from '@/supabase'

export default {
  async getProducts () {
    // Public data - can be fetched by anyone
    const { data: products, error: productsError } = await supabase
      .from('products')
      .select('*, product_variants(*), categories(id, name)')
      .eq('status', 'published')
      .order('created_at', { ascending: false })

    if (productsError) {
      console.error('Supabase error:', productsError)
      throw productsError
    }

    const { data: categories, error: categoriesError } = await supabase
      .from('categories')
      .select('*')

    if (categoriesError) {
      console.error('Supabase error:', categoriesError)
      throw categoriesError
    }

    // User-specific data - only fetch if user is logged in
    const user = supabase.auth.user()
    let cart = null

    if (user) {
      const { data: cartData, error: cartError } = await supabase
        .from('carts')
        .select('*, items:cart_items(*, products(*, product_variants(*)))')
        .eq('user_id', user.id)
        .maybeSingle() // Use maybeSingle() instead of single() to avoid 406 error

      if (cartError) {
        console.error('Supabase cart error:', cartError)
        // Don't throw error, just log it and continue
      } else {
        cart = cartData
      }
    }

    return {
      statusText: 'OK',
      data: {
        products: products || [],
        categories: categories || [],
        cart: cart || { items: [] }
      }
    }
  },

  async getProduct (productId) {
    const { data, error } = await supabase
      .from('products')
      .select('*, product_variants(*)') // Fetch the product and its variants
      .eq('id', productId)
      .eq('status', 'published')
      .single()

    if (error) {
      console.error('Supabase error:', error)
      throw error
    }

    return {
      statusText: 'OK',
      data: { product: data }
    }
  },

  async deleteItem (cartId, cartItemId) {
    // Cart functionality - keep for now or implement with Supabase later
    const { error } = await supabase
      .from('cart_items')
      .delete()
      .eq('id', cartItemId)

    if (error) {
      console.error('Supabase error:', error)
      throw error
    }

    return {
      statusText: 'OK'
    }
  }
}
